var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        form: _vm.form,
        "init-form": _vm.initForm,
        "is-show": _vm.isShowModel,
        "custom-title": _vm.dialogTitle,
        "save-item": _vm.saveItem,
        "can-submit": _vm.canSubmit,
        "is-only-confirm": _vm.mode === "view",
        "confirm-btn-text": _vm.mode === "view" ? "back" : "complete",
        "auto-height": "",
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isShowModel = $event
        },
        "update:is-show": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("doubleWeekPlan.input.taskType"),
                "label-width": _vm.formLabelWidth,
              },
            },
            [
              _c("FormSelect", {
                attrs: {
                  val: _vm.info.planTaskType,
                  options: _vm.formatPlanTypeOptions,
                  mode: "view",
                },
                on: {
                  "update:val": function ($event) {
                    return _vm.$set(_vm.info, "planTaskType", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.table.storeName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { val: _vm.info.storeName, mode: "view" },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "storeName", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "PCD",
                    label: _vm.$t("doubleWeekPlan.table.PCD"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormCascader", {
                    attrs: {
                      "target-form": _vm.info,
                      "key-list": [
                        "region",
                        "regionCode",
                        "city",
                        "cityCode",
                        "district",
                        "districtCode",
                      ],
                      mode: "view",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.table.storeAddress"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormTextArea", {
                    attrs: {
                      val: _vm.info.storeAddress,
                      rows: 4,
                      maxlength: 100,
                      mode: "view",
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "storeAddress", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("RangePick", {
            attrs: {
              "target-form": _vm.form,
              "key-list": ["planTaskStartTime", "planTaskEndTime"],
              "plan-task-date": _vm.info.planTaskDate,
              "actual-plan-task-flag": _vm.rangeFilter_actualPlanTaskFlag,
              "label-width": _vm.formLabelWidth,
              ptpk: _vm.info.planTaskInfoPk,
              mode: _vm.mode,
            },
          }),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.input.target1"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.info.visitPurposeOne,
                      options: _vm.optConfig.visitPurposeOptions,
                      mode: "view",
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "visitPurposeOne", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.input.target2"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.info.visitPurposeTwo,
                      options: _vm.optConfig.visitPurposeOptions,
                      mode: "view",
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "visitPurposeTwo", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "remark",
                rules: _vm.rules.validateIpt,
                label: _vm.$t("doubleWeekPlan.input.desc"),
                "label-width": _vm.formLabelWidth,
              },
            },
            [
              _c("FormTextArea", {
                attrs: {
                  val: _vm.form.remark,
                  rows: 4,
                  maxlength: "100",
                  mode: _vm.mode,
                },
                on: {
                  "update:val": function ($event) {
                    return _vm.$set(_vm.form, "remark", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("TimeConflictModel", {
        ref: "timeConflictModel",
        attrs: { "opt-config": _vm.optConfig },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }